(() => {
  const initQuiz = (shell) => {
    if (shell.dataset.fyqReady === 'true') return;
    shell.dataset.fyqReady = 'true';

    const start = shell.querySelector('[data-fyq-start]');
    const startButton = shell.querySelector('[data-fyq-start-button]');
    const steps = Array.from(shell.querySelectorAll('[data-fyq-step]'));
    const results = shell.querySelector('[data-fyq-results]');
    const progress = shell.querySelector('[data-fyq-progress] span');
    const productData = shell.querySelector('[data-fyq-products]');
    if (!start || !startButton || !steps.length || !results || !productData) return;

    let products;
    try {
      products = JSON.parse(productData.textContent);
    } catch (error) {
      return;
    }

    const answers = {};
    let currentStep = -1;

    const scoresFor = {
      cerebro: { focus: 5, coffee: 6, morning: 4, afternoon: 2, daily: 4, starter: 2 },
      matcha: { focus: 3, energy: 4, matcha: 7, afternoon: 4, daily: 3, starter: 2 },
      juices: { wellness: 7, caffeine_light: 6, reset: 6, yes: 2, local: 3, starter: 2 },
      coldbrew: { energy: 5, cold: 7, morning: 3, afternoon: 5, daily: 2 },
      bundles: { explore: 7, gift: 6, variety: 7, starter: 3 },
      miamibox: { explore: 4, gift: 5, yes: 7, visiting: 5, local: 8, variety: 3 }
    };

    const activeProducts = () => Object.entries(products).filter(([, product]) => product?.url && product.variantId);

    const updateProgress = () => {
      if (!progress) return;
      const completed = currentStep < 0 ? 0 : Math.min(currentStep, steps.length);
      progress.style.width = `${(completed / steps.length) * 100}%`;
    };

    const showStep = (index) => {
      start.hidden = true;
      results.classList.remove('is-active');
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === index));
      currentStep = index;
      updateProgress();
      steps[index]?.querySelector('h2')?.focus({ preventScroll: true });
    };

    const rankProducts = () => activeProducts()
      .map(([key, product]) => {
        const score = Object.values(answers).reduce((total, answer) => total + (scoresFor[key]?.[answer] || 0), 0);
        return { key, product, score };
      })
      .sort((a, b) => b.score - a.score);

    const fillProduct = (ranked) => {
      const { key, product } = ranked;
      shell.querySelector('[data-fyq-result-title]').textContent = product.title;
      shell.querySelector('[data-fyq-result-copy]').textContent = product.copy;
      shell.querySelector('[data-fyq-product-link]').href = product.url;
      shell.querySelector('[data-fyq-subscribe]').href = product.url;
      shell.querySelector('[data-fyq-result-tags]').innerHTML = product.tags.map((tag) => `<span class="fyq-tag">${tag}</span>`).join('');
      const nearby = shell.querySelector('[data-fyq-nearby]');
      nearby.classList.toggle('is-active', answers.miami === 'yes' || answers.miami === 'visiting' || key === 'miamibox');
      const addButton = shell.querySelector('[data-fyq-atc]');
      addButton.dataset.variantId = product.variantId || '';
      addButton.hidden = !product.variantId;
    };

    const showResults = () => {
      const ranked = rankProducts();
      if (!ranked.length) return;
      steps.forEach((step) => step.classList.remove('is-active'));
      fillProduct(ranked[0]);
      const runner = ranked[1] || ranked[0];
      shell.querySelector('[data-fyq-runner-title]').textContent = runner.product.title;
      shell.querySelector('[data-fyq-runner-copy]').textContent = runner.product.copy;
      shell.querySelector('[data-fyq-runner-link]').href = runner.product.url;
      results.classList.add('is-active');
      currentStep = steps.length;
      updateProgress();
      results.querySelector('h3')?.focus({ preventScroll: true });
    };

    startButton.addEventListener('click', () => showStep(0));

    steps.forEach((step, index) => {
      step.querySelectorAll('[data-fyq-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          answers[step.dataset.question] = button.dataset.fyqAnswer;
          step.querySelectorAll('[data-fyq-answer]').forEach((option) => option.classList.toggle('is-selected', option === button));
          if (index === steps.length - 1) showResults();
          else showStep(index + 1);
        });
      });
    });

    shell.querySelectorAll('[data-fyq-back]').forEach((button) => {
      button.addEventListener('click', () => {
        if (currentStep > 0) showStep(currentStep - 1);
        else {
          steps.forEach((step) => step.classList.remove('is-active'));
          results.classList.remove('is-active');
          start.hidden = false;
          currentStep = -1;
          updateProgress();
        }
      });
    });

    shell.querySelector('[data-fyq-atc]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add product');
        window.location.assign('/cart');
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Try again';
      }
    });

    shell.querySelector('[data-fyq-email-submit]')?.addEventListener('click', () => {
      const message = shell.querySelector('[data-fyq-email-message]');
      if (message) message.textContent = 'Your recommendation is shown above—save or screenshot it anytime.';
    });
  };

  const initialize = () => document.querySelectorAll('[data-fyq]').forEach(initQuiz);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
